var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g({ref:"message",staticClass:"hint-message",class:{
    'hint-message--open': _vm.isOpen,
    'hint-message--right': _vm.isRight,
    'hint-message--bottom': _vm.isBottom,
  },style:(_vm.messagePosition),on:{"click":function($event){$event.stopPropagation();}}},_vm.$listeners),[_c('p',{directives:[{name:"dompurify-html",rawName:"v-dompurify-html",value:(_vm.message),expression:"message"}],staticClass:"hint-message__text"})])
}
var staticRenderFns = []

export { render, staticRenderFns }